import { z } from 'zod';
/**
 * Períodos de tiempo disponibles para la Torre de Control y Dashboard Ejecutivo.
 */
export const PeriodoDashboardEsquema = z.enum([
    'este_mes',
    'trimestre',
    'ytd',
    '12_meses',
    'todos',
]);
export const FiltrosDashboardEsquema = z.object({
    periodo: PeriodoDashboardEsquema.optional().default('12_meses'),
    desde: z.string().optional(),
    hasta: z.string().optional(),
});
//# sourceMappingURL=dashboard.js.map